import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import Button from '../components/Button';
import CokeAndChips from '../assets/img/coke-and-chips-redeem.png';

const RedeemHeading = styled.h1`
  font-family: 'Speedee Bold';
  font-size: 72px;
  line-height: 0.95em;
  letter-spacing: -0.03em;
  margin: 0;
  text-align: center;
  color: #FFBC0D;
`;

const PrizeCode = styled.div`
  position: relative;
  margin: 0 15px;
  padding: 12px 64px 12px 24px;
  font-family: 'Speedee Bold';
  font-size: 32px;
  line-height: 1;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: -0.15px;
  border: 1px dotted rgba(45, 45, 45, 0.32);
  border-radius: 8px;
`;

const CopyButton = styled.button`
  position: absolute;
  top: 50%;
  right: 0;
  width: 64px;
  height: 64px;
  background: none;
  outline: none;
  border: none;
  transform: translateY(-50%);
  
  .btn-copy-text {
    font-size: 12px;
    color: #2D2D2D;
  }
`;

const HelpLink = styled.a`
  display: block;
  font-size: 14px; 
  line-height: 1.4;
  text-align: center;
  text-decoration: none;
  color: #2D2D2D;
  width: 100%;
  padding-top: 8px;
`;

function Claim({ ...props }) {
  const { prizeCode, setPage } = props;
  const [hasCopied, setHasCopied] = useState(false);

  const copyCode = useCallback(() => {
    navigator.clipboard.writeText(prizeCode);
    setHasCopied(true);
  }, [prizeCode]);

  return (
    <>
      <RedeemHeading>Success!</RedeemHeading>
      <p style={{ textAlign: 'center', fontSize: 16, lineHeight: 0.95, letterSpacing: '-0.15px', margin: '24px 0 12px' }}>Your code is</p>
      <PrizeCode>
        { prizeCode }
        <CopyButton onClick={copyCode}>
          {!hasCopied && (
            <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28" fill="none">
              <g clip-path="url(#clip0_860_5486)">
                <path d="M16.3116 1.54443L21.7364 7.05517C22.542 7.88232 22.8106 8.72021 22.8106 10.0415V18.7641C22.8106 20.9985 21.6934 22.1372 19.4805 22.1372H17.6006V20.4077H19.3838C20.501 20.4077 21.0811 19.8061 21.0811 18.7319V9.54737H16.0537C14.8184 9.54737 14.2168 8.95654 14.2168 7.71044V2.1997H9.46875C8.35156 2.1997 7.78222 2.81202 7.78222 3.87548V5.83056H6.05273V3.84326C6.05273 1.60888 7.16992 0.470215 9.38281 0.470215H13.4971C14.6465 0.470215 15.5489 0.760254 16.3116 1.54443ZM15.7744 7.45263C15.7744 7.82861 15.9248 7.98974 16.3008 7.98974H20.6299L15.7744 3.04833V7.45263Z" fill="#FFBC0D"/>
                <path d="M0.84375 24.1245C0.84375 26.3696 1.9502 27.4975 4.17383 27.4975H14.2715C16.4951 27.4975 17.6015 26.3589 17.6015 24.1245V15.7348C17.6015 14.3598 17.4405 13.7583 16.581 12.8774L10.6621 6.85108C9.8457 6.01319 9.16895 5.83057 7.96582 5.83057H4.17383C1.96094 5.83057 0.84375 6.9585 0.84375 9.20362V24.1245ZM2.57324 24.0923V9.2251C2.57324 8.17237 3.14258 7.56006 4.25977 7.56006H7.7832V13.7905C7.7832 15.144 8.4707 15.8208 9.80273 15.8208H15.8721V24.0923C15.8721 25.1665 15.292 25.7681 14.1855 25.7681H4.24902C3.14258 25.7681 2.57324 25.1665 2.57324 24.0923ZM10.0068 14.1987C9.57715 14.1987 9.40527 14.0268 9.40527 13.5972V7.95752L15.5391 14.1987H10.0068Z" fill="#FFBC0D"/>
              </g>
              <defs>
                <clipPath id="clip0_860_5486">
                  <rect width="22.3115" height="27.0596" fill="white" transform="translate(0.84375 0.470215)"/>
                </clipPath>
              </defs>
            </svg>
            <span className='btn-copy-text'>Copy</span>
            </>
          )}
          {hasCopied && (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_209_15675)">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.6744 20.8505L23.8059 3.21872L22.4109 2.19862C21.6405 1.63523 20.573 1.82238 20.0265 2.61663L10.0486 17.1184L1.94888 8.87792L0.747581 10.1329C0.0841193 10.826 0.091291 11.9424 0.763599 12.6264L9.07815 21.0853C9.82874 21.849 11.0643 21.7372 11.6744 20.8505Z" fill="#FFBC0D"/>
            </g>
            <defs>
            <clipPath id="clip0_209_15675">
            <rect width="24" height="24" fill="white"/>
            </clipPath>
            </defs>
            </svg>
          )}
        </CopyButton>
      </PrizeCode>
      <p style={{ fontSize: 18, lineHeight: 1.4, letterSpacing: '-0.15px', textAlign: 'center' }}>Click 'Redeem' to claim your reward in the MyMacca's&reg; app.</p>
      <a 
        href={`https://mcdvouchers.page.link/?link=https://mcdonalds.com.au/mobileordering/vouchers?code=${prizeCode}&apn=com.mcdonalds.au.gma&isi=1105300599&ibi=com.mcdonalds.gma.au`} 
        target="_blank" 
        rel='noreferrer'
        style={{ textDecoration: "none"}}>
          <Button>Redeem</Button>
      </a>
      <HelpLink
        onClick={() => setPage('code-not-working')}
      >
        Link not working?
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: "bottom", marginLeft: "4px" }}>
          <path fillRule="evenodd" clipRule="evenodd" d="M11.1233 10.2816H9.18699C9.22635 9.52595 9.492 8.92577 9.98395 8.48104C10.4759 8.03631 11.1587 7.81395 12.0324 7.81395C12.5834 7.81395 13.0714 7.9025 13.4965 8.07961C13.9215 8.25671 14.2521 8.50859 14.4883 8.83525C14.7244 9.16191 14.8425 9.54956 14.8425 9.99822C14.8425 10.4626 14.7362 10.8385 14.5237 11.1258C14.3112 11.4131 14.0199 11.6905 13.65 11.9582L13.1187 12.3478C12.9219 12.4895 12.794 12.6351 12.735 12.7846C12.6759 12.9342 12.6464 13.1034 12.6464 13.2923V13.4104H10.8399V13.0562C10.8399 12.702 10.9069 12.4088 11.0407 12.1766C11.1745 11.9444 11.4106 11.6945 11.7491 11.4269L12.1977 11.0726C12.4181 10.8995 12.5657 10.7421 12.6405 10.6004C12.7153 10.4587 12.7527 10.2698 12.7527 10.0336C12.7527 9.81325 12.6877 9.62434 12.5578 9.46691C12.428 9.30949 12.241 9.23078 11.997 9.23078C11.7451 9.23078 11.5425 9.31539 11.389 9.48462C11.2355 9.65386 11.1469 9.91951 11.1233 10.2816ZM11.7373 14.5258C12.0443 14.5258 12.3001 14.6242 12.5048 14.821C12.7094 15.0178 12.8117 15.2736 12.8117 15.5885C12.8117 15.8797 12.7055 16.1296 12.4929 16.3382C12.2804 16.5468 12.0285 16.6511 11.7373 16.6511C11.4382 16.6511 11.1863 16.5468 10.9817 16.3382C10.777 16.1296 10.6747 15.8797 10.6747 15.5885C10.6747 15.2736 10.777 15.0178 10.9817 14.821C11.1863 14.6242 11.4382 14.5258 11.7373 14.5258Z" fill="#292929"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25Z" fill="#292929"/>
        </svg>
      </HelpLink>
      <img src={CokeAndChips} alt='' style={{ position: 'absolute', bottom: 40, right: 0, width: '100%' }}/>
    </>
  );
}

export default Claim;